

const StatistiqueReducer = (state, action) => {
    switch (action.type) {
        case "GET_STATISTIQUES_START":
            return {
                ...state,
                statistiques: {},
                isFetchingGet: true,
                errorGet: false,
            };
        case "GET_STATISTIQUES_SUCCESS":
            return {
                ...state,
                statistiques: action.payload,
                isFetchingGet: false,
                errorGet: false,
            };
        case "GET_STATISTIQUES_FAILURE":
            return {
                ...state,
                statistiques: {},
                isFetchingGet: false,
                errorGet: action.payload,
            };
        case "CLEAR_STATISTIQUES":
            return {
                ...state,
                statistiques: {},
            };
        default:
            return { ...state };
    }
}

export default StatistiqueReducer;